import styled from 'styled-components';
import { path } from '../../../../../common/css/setting/variable';

const Label = styled.span`
  display: inline-block;
  width: 42px;
  height: 12px;
  font-size: 0; /* 意図しない余白を生まないため */
  vertical-align: middle;
  background-image: url(${path.img_label_original});
  background-repeat: no-repeat;
  background-size: 42px 12px;
`;

const OriginalLabel: React.FC = () => {
  return <Label>オリジナル</Label>;
};
export default OriginalLabel;
